import { useMemo } from 'react';
import { useItemsStore } from '../store';
import { Category, Product } from '../interfaces/domain/menu';

export const useMainPlates = () => {
    // 1. SELECTORES ATÓMICOS
    // Solo escuchamos categorías y features. Ignoramos cambios en info del restaurante.
    const categories = useItemsStore(state => state.menuData?.categories);
    const featuresData = useItemsStore(state => state.featuresData);

    // 2. PROCESAMIENTO MEMOIZADO
    const sections = useMemo(() => {
        if (!categories || !featuresData) return [];

        const getAllAvailableProducts = (cats: Category[]): Product[] =>
            cats.flatMap((cat) => (cat.products ?? []).filter((p) => p.is_available));

        const allAvailable = getAllAvailableProducts(categories);

        const productMap = new Map(allAvailable.map(p => [p.id, p]));

        const productOrderMap = new Map<string, { catPos: number; prodPos: number }>();
        categories.forEach((cat) => {
            (cat.products ?? []).forEach((p) => {
                productOrderMap.set(p.id, { catPos: cat.position, prodPos: p.position });
            });
        });

        return [...featuresData]
            .sort((a, b) => (a.priority ?? 999) - (b.priority ?? 999))
            .map(feature => ({
                title: feature.name,
                products: feature.items
                    .map(id => productMap.get(id))
                    .filter((p): p is Product => !!p)
                    .sort((a, b) => {
                        const aOrd = productOrderMap.get(a.id) ?? { catPos: 999, prodPos: 999 };
                        const bOrd = productOrderMap.get(b.id) ?? { catPos: 999, prodPos: 999 };
                        if (aOrd.catPos !== bOrd.catPos) return aOrd.catPos - bOrd.catPos;
                        return aOrd.prodPos - bOrd.prodPos;
                    }),
            }))
            .filter(section => section.products.length > 0);
            
    }, [categories, featuresData]);

    return {
        sections,
        hasData: sections.length > 0
    };
};